module.exports = __webpack_public_path__ + "static/06-4bc7a84922de28318f2ec45282e1bffe.jpg";